import { Step, StepContent, StepLabel, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";
import { DoneIcon } from "./StepIcons";
import TransactionHistoryBase from "./TransactionHistoryBase";
import styles from "./styles";
import Note from "./Note";

const WithoutOrderIdBuy = ({
  amount,
  unit,
  completedDate,
  details,
  salesChargeAmount,
  salesChargePercent,
  type,
}) => {
  const { serviceTaxAmount = 0, serviceTaxRate = 0 } =
    details?.find(d => d.type === type) || {};

  return (
    <TransactionHistoryBase>
      {/* Completed */}
      <Step active>
        <StepLabel icon={<DoneIcon active />}>
          <Typography
            color="textPrimary"
            style={{
              ...styles.baseFont,
              ...styles.label,
              color: "#000000",
            }}
          >
            Completed
          </Typography>
        </StepLabel>
        <StepContent style={{ marginTop: "0" }}>
          <div
            style={{
              marginTop: "3px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              Adjusted Cash In
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              <NumberFormat
                prefix="RM"
                value={amount}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            </Typography>
          </div>
          <div
            style={{
              marginTop: "3px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              Sales Charge ({salesChargePercent || 0}%)
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              <NumberFormat
                prefix="RM"
                value={salesChargeAmount || 0}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            </Typography>
          </div>
          {/* START: SST */}
          <div
            style={{
              marginTop: "3px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              SST ({serviceTaxRate || 0}%)
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
              }}
            >
              <NumberFormat
                prefix="RM"
                value={serviceTaxAmount || 0}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            </Typography>
          </div>
          {/* END: SST */}
          <div
            style={{
              marginTop: "3px",
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "700",
              color: "#616367",
            }}
          >
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
                fontWeight: "inherit",
                color: "inherit",
              }}
            >
              Net amount
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
                fontWeight: "inherit",
                color: "inherit",
              }}
            >
              <NumberFormat
                prefix="RM"
                value={amount - salesChargeAmount - serviceTaxAmount}
                thousandSeparator
                displayType="text"
                decimalScale={2}
                fixedDecimalScale
              />
            </Typography>
          </div>
          <div
            style={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography style={{ ...styles.baseFont, ...styles.content }}>
              Unit: {unit}
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                ...styles.content,
                textAlign: "right",
              }}
            >
              Unit Price:
              <NumberFormat
                prefix="RM"
                value={
                  details &&
                  details.length > 0 &&
                  details[0].actualUnitPrice !== null
                    ? details[0].actualUnitPrice
                    : parseFloat(amount / unit)
                }
                thousandSeparator
                displayType="text"
                decimalScale={4}
                fixedDecimalScale
              />
            </Typography>
          </div>

          <Typography
            style={{
              ...styles.baseFont,
              ...styles.content,
              ...styles.date,
              marginTop: "8px",
            }}
          >
            {moment(completedDate)
              .utcOffset("+0800")
              .format("DD MMM YYYY")}
          </Typography>
        </StepContent>
        <Note>
          Note: This transaction is the adjusted Cash In for your initial Cash
          In you did.
        </Note>
      </Step>
    </TransactionHistoryBase>
  );
};

export default WithoutOrderIdBuy;
